export { default as VictoryBoxPlot } from "./victory-box-plot";


//////////////////
// WEBPACK FOOTER
// ./~/victory-box-plot/es/index.js
// module id = ./node_modules/victory-box-plot/es/index.js
// module chunks = 1